import { Link, Stack, Typography } from '@common-components';
import { messages } from 'i18n';

export const MismatchVersionNotification = () => (
  <Stack direction="row" gap={1}>
    <Stack direction="column" gap={0.5}>
      <Typography variant="body1Bold">{messages.serverVersionMismatch.title}</Typography>
      <Typography variant="body2">
        {messages.serverVersionMismatch.description}{' '}
        <Link onClick={() => window.location.reload()} sx={{ cursor: 'pointer' }}>
          {messages.serverVersionMismatch.action}
        </Link>
      </Typography>
    </Stack>
  </Stack>
);
